/**
 * Pull a clinic invitation code out of a scanned QR value.
 *
 * The clinic encodes a URL — `${PATIENT_ORIGIN}/join/${invitationCode}` — so the
 * code is the last path segment. Parsing the URL, rather than regex-matching the
 * tail, keeps this correct when the URL carries a trailing slash or a query
 * string; a tail match would otherwise hand the entire URL over as the "code"
 * and the join would fail with a confusing "invalid code" error.
 *
 * A raw code — typed, or from a code-only QR — passes straight through.
 */
export function extractCode(raw) {
  try {
    const url = new URL(raw);
    const m = url.pathname.match(/\/join\/([^/?#]+)/);
    if (m) return m[1];
  } catch { /* not a URL — treat as a raw code */ }
  return String(raw ?? '').trim();
}
